import { Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { RootState } from '../services/store';
import { MeRoutesEnum, RoutesEnum } from '../models/enums/routes.enum';
import { useGlobals } from '../contexts/appContext';
import { getUserSettings } from '../services/userService';
import { User } from '../models/user';
import ConsoleHelper from '../functions/consoleHelper';
import { UserAccountTypeEnum } from '../models/enums/userAccountType.enum';

const RequireUser = ({ children }: { children: JSX.Element }) => {
  const location = useLocation();
  const user = useSelector((state: RootState) => state.oidc.user);
  const { setCurrentUser } = useGlobals();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchUser = async () => {
      const result = await getUserSettings();
      const userResult = result.data as User;
      setCurrentUser(userResult);
      ConsoleHelper.log('USER/ME', result.data);
      setIsLoading(false);
    };
    if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.User) {
      fetchUser();
    } else {
      setIsLoading(false);
    }
  }, [user, setCurrentUser]);

  if (isLoading) {
    return <div />;
  }
  if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.User) {
    return <Suspense fallback={<div />}>{children}</Suspense>;
  }
  if (user && !user.expired && user.profile.accountType === UserAccountTypeEnum.Member) {
    return <Navigate to={MeRoutesEnum.MemberDashboard} state={{ from: location }} replace />;
  }
  return <Navigate to={RoutesEnum.Login} state={{ from: location }} replace />;
};

export default RequireUser;
